<template>
  <div class="content">
    <div class="row mt-5">
      <div class="col-md-12">
        <h3>SUIVI CONTACTS <small class="text-muted">v2</small></h3>

        <!-- Filters (quality - same as v1) -->
        <div class="card">
          <div class="card-body">
            <div class="col-md-12">
              <div class="row">
                <div class="col-xl-10 col-lg-12 col-12 order-xl-1 order-1">
                  <div class="row">
                    <base-input label="Pack" class="col-md-4 mb-2">
                      <el-select filterable class="select-primary" clearable placeholder="CHOISISSEZ" v-model="PackSelects.Pack">
                        <el-option
                          v-for="option in PackSelects.ListPack"
                          class="select-primary"
                          :value="option.value"
                          :label="option.label"
                          :key="option.value || 'all'"
                        />
                      </el-select>
                    </base-input>
                    <base-input label="Facturation" class="col-md-4 mb-2">
                      <el-select filterable class="select-primary" clearable placeholder="CHOISISSEZ" v-model="FabricationSelects.Fabrication">
                        <el-option
                          v-for="option in FabricationSelects.ListFabrication"
                          class="select-primary"
                          :value="option.value"
                          :label="option.label"
                          :key="option.value"
                        />
                      </el-select>
                    </base-input>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-12 col-12 order-xl-2 order-3">
                  <div class="row">
                    <base-button
                      v-if="$apollo.queries.MyLeads.loading || crmLoading"
                      loading
                      class="btn btn-just-icon btn-default mt-4 d-block"
                    >{{ $t('buttons.BtnLoad').toUpperCase() }}...</base-button>
                    <button
                      v-else
                      class="btn btn-just-icon btn-default mt-4 d-block"
                      @click="search"
                    >{{ $t('buttons.BtnSearch').toUpperCase() }}</button>
                  </div>
                </div>
                <div class="col-xl-10 col-lg-12 col-12 order-xl-1 order-2">
                  <div class="row">
                    <base-input label="Statut qualité" class="col-md-4 mb-2">
                      <el-select filterable class="select-primary" clearable placeholder="CHOISISSEZ" v-model="StatutSelects.Statut">
                        <el-option
                          v-for="option in StatutSelects.ListStatut"
                          class="select-primary"
                          :value="option.value"
                          :label="option.label"
                          :key="option.value || 'all-q'"
                        />
                      </el-select>
                    </base-input>
                    <base-input class="col-md-4 mb-2" label="Date début">
                      <el-date-picker v-model="StartDate" value-format="yyyy-MM-dd" type="date" placeholder="YYYY-MM-DD" />
                    </base-input>
                    <base-input class="col-md-4 mb-2" label="Date fin">
                      <el-date-picker v-model="EndnDate" value-format="yyyy-MM-dd" type="date" placeholder="YYYY-MM-DD" />
                    </base-input>
                  </div>
                  <div class="row mb-2">
                    <div class="col-12">
                      <span class="small text-muted mr-2">Période rapide :</span>
                      <button type="button" class="btn btn-sm btn-default mr-1 mb-1" @click="applyDatePreset('today')">
                        Aujourd'hui
                      </button>
                      <button type="button" class="btn btn-sm btn-default mr-1 mb-1" @click="applyDatePreset('yesterday')">
                        Hier
                      </button>
                      <button type="button" class="btn btn-sm btn-default mr-1 mb-1" @click="applyDatePreset(7)">
                        7 jours
                      </button>
                      <button type="button" class="btn btn-sm btn-default mb-1" @click="applyDatePreset(30)">
                        30 jours
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-12 order-3">
                  <div class="row">
                    <button class="btn btn-market" @click="DownloadCSV">
                      <i class="tim-icons icon-cloud-download-93"></i> EXPORT CSV
                    </button>
                    &nbsp;
                    <base-checkbox inline class="mb-2 col-sm-4" v-model="With_fields">
                      avec les champs du produit
                    </base-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <crm-kpis :items="kpiItems" :active-key="kpiFilter" @filter="onKpiFilter" />

        <div class="card mb-3">
          <div class="card-body py-3">
            <div class="row align-items-end">
              <base-input class="col-md-4 mb-0" label="Opérateur (session)">
                <el-select
                  class="select-primary w-100"
                  v-model="operatorId"
                  @change="onOperatorChange"
                  placeholder="Compte annonceur"
                >
                  <el-option value="" label="Compte annonceur" />
                  <el-option
                    v-for="c in activeCommercials"
                    :key="c.id"
                    :value="String(c.id)"
                    :label="commercialLabel(c)"
                  />
                </el-select>
              </base-input>
              <div class="col-md-8 mb-2">
                <p class="small text-muted mb-0">
                  Choisissez le commercial qui traite les contacts sur ce poste.
                  Les actions CRM seront historisées sous ce nom. En mode commercial,
                  le filtre « mes contacts » s’applique automatiquement.
                </p>
              </div>
            </div>
          </div>
        </div>

        <commercials-panel
          :commercials="commercials"
          :submitting="commercialSubmitting"
          @create="onCreateCommercial"
          @disable="onDisableCommercial"
          @enable="onEnableCommercial"
        />

        <div
          ref="crmWorkspace"
          class="row crm-workspace"
          :class="{ 'crm-workspace-split': selectedLead && !fullFiche }"
        >
          <div
            class="crm-list-col"
            :class="selectedLead && !fullFiche ? 'col-xl-7' : 'col-xl-12'"
          >
            <div class="card">
              <div class="card-body">
                <div class="crm-table-filters mb-2">
                  <div class="crm-filters-primary d-flex flex-wrap align-items-end">
                    <base-input label="Rechercher" class="crm-search-wrap mb-2">
                      <el-input
                        id="crm-search-input"
                        ref="crmSearchInput"
                        type="search"
                        class="crm-search-input"
                        clearable
                        prefix-icon="el-icon-search"
                        placeholder="Nom, téléphone, email, CP, n° lead…"
                        v-model="searchQuery"
                      />
                    </base-input>
                    <base-input label="Produit" class="crm-filter-item mb-2">
                      <el-select
                        filterable
                        class="select-primary w-100"
                        clearable
                        placeholder="Tous"
                        v-model="crmProductFilter"
                        @change="pagination.currentPage = 1"
                      >
                        <el-option value="" label="Tous les produits" />
                        <el-option
                          v-for="option in ProductSelects.ListProduct"
                          class="select-primary"
                          :key="option.pk_categorie"
                          :value="String(option.pk_categorie)"
                          :label="(option.designation || '').replace(/Ã©/g,'é').toUpperCase()"
                        />
                      </el-select>
                    </base-input>
                    <base-input label="Statut CRM" class="crm-filter-item mb-2">
                      <el-select filterable class="select-primary w-100" clearable placeholder="Tous" v-model="crmStatusFilter">
                        <el-option value="" label="TOUS LES STATUTS CRM" />
                        <el-option
                          v-for="s in crmStatuses"
                          :key="s.id"
                          :value="s.id"
                          :label="s.label"
                        />
                        <el-option value="__4_CALLS__" label="4 appels atteints" />
                      </el-select>
                    </base-input>
                    <base-input label="Commercial" class="crm-filter-item mb-2">
                      <el-select filterable class="select-primary w-100" clearable placeholder="Tous" v-model="commercialFilter">
                        <el-option value="" label="TOUS" />
                        <el-option value="__UNASSIGNED__" label="Non affecté" />
                        <el-option
                          v-for="c in activeCommercials"
                          :key="c.id"
                          :value="String(c.id)"
                          :label="commercialLabel(c)"
                        />
                      </el-select>
                    </base-input>
                    <base-input label="Rappel" class="crm-filter-item mb-2">
                      <el-select
                        class="select-primary w-100"
                        clearable
                        placeholder="Tous"
                        v-model="rappelFilter"
                        @change="onRappelFilterChange"
                      >
                        <el-option value="" label="Tous les rappels" />
                        <el-option value="today" label="Rappels du jour" />
                        <el-option value="upcoming" label="Rappels à venir" />
                        <el-option value="overdue" label="En retard" />
                      </el-select>
                    </base-input>
                    <base-input v-if="tarificationCrmEnabled" label="Tarification" class="crm-filter-item mb-2">
                      <el-select
                        class="select-primary w-100"
                        clearable
                        placeholder="Tous"
                        v-model="tarificationFilter"
                      >
                        <el-option value="" label="Toutes" />
                        <el-option value="bons_conducteurs" label="Tarification Coverity" />
                        <el-option value="auto_rag" label="Tarification autre" />
                      </el-select>
                    </base-input>
                    <div class="crm-filters-actions d-flex align-items-end mb-2 ml-auto">
                      <button
                        v-if="activeFilterChips.length"
                        type="button"
                        class="btn btn-sm btn-default mb-0 mr-2"
                        @click="clearAllTableFilters"
                      >
                        Réinitialiser
                      </button>
                      <base-dropdown
                        v-if="!selectedLead"
                        menu-classes="dropdown-black"
                        class="crm-cols-toggle mb-0"
                      >
                        <template slot="title-container">
                          <button type="button" class="btn btn-icon btn-round btn-market mb-0">
                            <i class="tim-icons el-icon-view"></i>
                          </button>
                        </template>
                        <template v-for="row in rows">
                          <div
                            class="dropdown-header"
                            :key="row.label"
                            v-if="!row.heomiOnly || tarificationCrmEnabled"
                          >
                            <base-checkbox v-model="row.show">{{ row.label }}</base-checkbox>
                          </div>
                        </template>
                      </base-dropdown>
                    </div>
                  </div>
                  <div v-if="!selectedLead" class="crm-filters-secondary d-flex flex-wrap align-items-end mt-1">
                    <base-input label="Âge" class="crm-filter-item mb-2">
                      <el-select class="select-primary w-100" clearable placeholder="Tous" v-model="ageFilter">
                        <el-option value="" label="Tous les âges" />
                        <el-option value="under21" label="Moins de 21 ans" />
                        <el-option value="over21" label="Plus de 21 ans" />
                      </el-select>
                    </base-input>
                    <base-input label="Code postal" class="crm-filter-item mb-2">
                      <el-input
                        class="w-100"
                        clearable
                        placeholder="Ex. 75 ou 75001"
                        v-model="cpFilter"
                      />
                    </base-input>
                  </div>
                  <div class="crm-filter-chips d-flex flex-wrap align-items-center mt-1">
                    <button
                      v-for="chip in activeFilterChips"
                      :key="chip.key"
                      type="button"
                      class="btn btn-sm btn-default crm-filter-chip mr-1 mb-1"
                      @click="clearFilter(chip.key)"
                    >
                      {{ chip.label }}
                      <span class="crm-filter-chip-x" aria-hidden="true">&times;</span>
                    </button>
                    <span class="small text-muted ml-auto mb-1">
                      <template v-if="total === 0 && activeFilterChips.length">Aucun résultat</template>
                      <template v-else>{{ total }} contact{{ total > 1 ? 's' : '' }}</template>
                    </span>
                  </div>
                </div>

                <el-table
                  ref="leadsTable"
                  :data="filterlistMylead"
                  row-key="pk_lead"
                  :row-class-name="tarificationRowClassName"
                  v-loading="$apollo.queries.MyLeads.loading || crmLoading || crmStateSaving || bulkAssigning"
                  class="customtable_leads"
                  highlight-current-row
                  @row-click="onRowClick"
                  @row-dblclick="openFullFiche"
                  @selection-change="onSelectionChange"
                >
                  <el-table-column type="selection" width="42" />
                  <el-table-column prop="date_livraison" label="Date" minWidth="110" show-overflow-tooltip sortable v-if="rows[0].show" />
                  <el-table-column prop="pk_bon_commande" label="N° commande" minWidth="130" show-overflow-tooltip sortable v-if="rows[1].show" />
                  <el-table-column prop="pk_lead" label="Ref" minWidth="80" show-overflow-tooltip sortable v-if="rows[2].show" />
                  <el-table-column prop="categorie" label="Produit" minWidth="150" show-overflow-tooltip sortable v-if="rows[3].show">
                    <template slot-scope="scope">
                      <span class="crm-product-cell">
                        <i
                          :class="productIconClass(scope.row.categorie)"
                          :title="productLabel(scope.row.categorie)"
                          class="crm-product-icon"
                        />
                        <span>{{ productLabel(scope.row.categorie) }}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="pack" label="Gamme" min-width="100" show-overflow-tooltip sortable v-if="rows[4].show">
                    <template slot-scope="scope">{{ (scope.row.pack || '').toUpperCase() }}</template>
                  </el-table-column>
                  <el-table-column label="Contact" prop="nom" min-width="150" show-overflow-tooltip sortable v-if="rows[5].show">
                    <template slot-scope="scope">
                      <strong>{{ ((scope.row.nom || '') + ' ' + (scope.row.prenom || '')).toUpperCase() }}</strong><br />
                      <small>{{ scope.row.telephone }}</small>
                    </template>
                  </el-table-column>
                  <el-table-column label="Téléphone" prop="telephone" min-width="120" show-overflow-tooltip sortable v-if="rows[6].show" />
                  <el-table-column label="Code postal" prop="cp" min-width="100" show-overflow-tooltip v-if="rows[7].show" />
                  <el-table-column label="Email" prop="email" min-width="120" show-overflow-tooltip sortable v-if="rows[8].show" />
                  <el-table-column label="Facturation" prop="facturation" min-width="110" show-overflow-tooltip v-if="rows[9].show">
                    <template slot-scope="scope">{{ (scope.row.facturation || '').toUpperCase() }}</template>
                  </el-table-column>
                  <el-table-column label="Date de collecte" prop="date_collecte" min-width="130" show-overflow-tooltip sortable v-if="rows[10].show" />
                  <el-table-column label="Phrase d'optin" prop="phrase_optin" min-width="160" show-overflow-tooltip v-if="rows[11].show" />
                  <el-table-column label="Site du collecte" prop="site_collecte" min-width="140" show-overflow-tooltip sortable v-if="rows[12].show" />
                  <el-table-column label="Annuaire" min-width="120" v-if="rows[13].show">
                    <template slot-scope="scope">
                      <a
                        target="_blank"
                        :href="'http://www.118218.fr/recherche?geo_id=&distance=&category=&who=' + encode_utf8(scope.row.nom) + '&where=' + encode_utf8(scope.row.ville)"
                      >
                        <input type="button" class="btn btn-theme btn-sm" value="118 218" />
                      </a>
                    </template>
                  </el-table-column>
                  <el-table-column label="Appels" min-width="90" v-if="rows[16].show">
                    <template slot-scope="scope">
                      <span class="crm-dots">
                        <i
                          v-for="n in 4"
                          :key="n"
                          class="fa fa-circle"
                          :class="dotClass(crmOf(scope.row).calls_count, n)"
                          style="font-size: 8px; margin-right: 2px;"
                        />
                      </span>
                      {{ crmOf(scope.row).calls_count || 0 }}/4
                    </template>
                  </el-table-column>
                  <el-table-column label="Rappel" min-width="140" show-overflow-tooltip v-if="rows[20] && rows[20].show">
                    <template slot-scope="scope">
                      <span
                        :class="{
                          'text-warning': callbackRelative(crmOf(scope.row).callback_at) === 'overdue',
                          'text-info': callbackRelative(crmOf(scope.row).callback_at) === 'today'
                        }"
                      >{{ prettyCallbackAt(crmOf(scope.row).callback_at) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Tarification"
                    min-width="150"
                    v-if="tarificationCrmEnabled && rows[21] && rows[21].show"
                  >
                    <template slot-scope="scope">
                      <span
                        v-if="tarificationLabel(scope.row)"
                        class="badge badge-pill"
                        :class="tarificationBadgeClass(scope.row)"
                      >{{ tarificationLabel(scope.row) }}</span>
                      <span v-else class="text-muted">—</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Statut CRM" min-width="130" v-if="rows[17].show">
                    <template slot-scope="scope">
                      <span class="badge badge-pill" :class="'badge-' + statusMeta(crmOf(scope.row).status).badge">
                        {{ statusMeta(crmOf(scope.row).status).label }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Commercial" min-width="130" v-if="rows[18] && rows[18].show">
                    <template slot-scope="scope">
                      {{ crmOf(scope.row).owner_commercial_name || 'Non affecté' }}
                    </template>
                  </el-table-column>
                  <el-table-column label="Pièces" min-width="90" v-if="rows[19] && rows[19].show">
                    <template slot-scope="scope">
                      {{ piecesCollectedCount(crmOf(scope.row)) }}/3
                    </template>
                  </el-table-column>
                  <el-table-column label="Statut du lead" prop="statut" min-width="130" show-overflow-tooltip v-if="rows[14].show">
                    <template slot-scope="scope">
                      <template v-if="scope.row.statut == 'ok' || scope.row.statut == 'Ok'">VALIDE</template>
                      <template v-else-if="scope.row.statut == 'devalide'">DÉVALIDATION ACCEPTÉE</template>
                      <template v-else-if="scope.row.statut == 'en cours de verification'">EN COURS DE TRAITEMENT</template>
                      <template v-else-if="scope.row.statut == 'demande refusee'">DÉVALIDATION REFUSÉE</template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Demande de dévalidation"
                    :render-header="renderHeaderMethod"
                    min-width="230"
                    v-if="rows[15].show"
                  >
                    <template slot-scope="scope">
                      <base-input>
                        <el-select
                          class="select-primary"
                          :disabled="checkDevalidation(scope.row)"
                          filterable
                          @change="StatChanged(scope.row)"
                          v-model="scope.row.motif"
                          @click.native.stop
                        >
                          <el-option class="select-primary" value="" label="-- CHOISIR --" />
                          <el-option class="select-primary" value="aucune demande" label="N'A FAIT AUCUNE DEMANDE" />
                          <el-option class="select-primary" value="faux numero de telephone" label="FAUX NUMÉRO DE TÉLÉPHONE" />
                          <el-option class="select-primary" value="numero non attribue" label="NUMÉRO NON ATTRIBUÉ" />
                        </el-select>
                      </base-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="!(selectedLead && !fullFiche)"
                    label="Fiche"
                    min-width="78"
                    width="78"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <button
                        class="btn btn-sm btn-market btn-ouvrir"
                        @click.stop="openFullFiche(scope.row)"
                      >Ouvrir</button>
                    </template>
                  </el-table-column>
                </el-table>

                <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap align-items-center mt-3">
                  <div class="d-flex flex-wrap align-items-center">
                    <base-input label="Afficher" class="crm-perpage-wrap mb-0 mr-3">
                      <el-select class="select-primary pagination-select" v-model="pagination.perPage" placeholder="Per page">
                        <el-option
                          class="select-primary"
                          v-for="item in pagination.perPageOptions"
                          :key="item"
                          :label="item"
                          :value="item"
                        />
                      </el-select>
                    </base-input>
                    <p class="card-category mb-0">
                      {{ $t('labels.Datatable.Showing') }} {{ from + 1 }} {{ $t('labels.Datatable.to') }} {{ to }}
                      {{ $t('labels.Datatable.of') }} {{ total }} {{ $t('labels.Datatable.entries') }}
                    </p>
                  </div>
                  <base-pagination
                    type="market"
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-xl-5 crm-fiche-col"
            ref="ficheCol"
            v-if="selectedLead && !fullFiche"
          >
            <!-- Keeps the grid column width while the panel is fixed -->
            <div class="crm-fiche-dock-spacer" :style="{ height: ficheSpacerPx + 'px' }"></div>
            <div
              ref="ficheDock"
              class="crm-fiche-dock"
              :class="{ 'is-fixed': !!ficheDockStyle }"
              :style="ficheDockStyle || {}"
            >
              <contact-fiche
                :lead="selectedLead"
                :crm="crmOf(selectedLead)"
                :commercials="commercials"
                :field-groups="selectedFieldGroups"
                :details-loading="detailsLoading"
                :mg-unavailable="detailsMgUnavailable"
                :mg-consent="detailsMgConsent"
                :state-saving="crmStateSaving"
                :comment-draft="commentDraft"
                :comment-saving="commentSaving"
                :show-tarification="tarificationCrmEnabled"
                @update:commentDraft="commentDraft = $event"
                @close="selectedLead = null"
                @open-full="openFullFiche(selectedLead)"
                @open-call="callOpen = true"
                @open-sms="openSms"
                @update-state="updateCrmState"
                @add-comment="addComment"
              />
            </div>
          </div>
        </div>

        <!-- FAB sélection → popup affectation commercial (ne pousse pas le tableau) -->
        <button
          v-if="selectedRows.length && !bulkAssignOpen"
          type="button"
          class="crm-bulk-fab"
          :disabled="bulkAssigning"
          @click="bulkAssignOpen = true"
        >
          <i class="tim-icons icon-single-02" />
          <span class="crm-bulk-fab-count">{{ selectedRows.length }}</span>
          <span class="crm-bulk-fab-label">Affectation</span>
        </button>

        <modal
          :show.sync="bulkAssignOpen"
          class="modal-crm"
          body-classes="pt-2"
          :show-close="true"
          :close-on-click-outside="false"
        >
          <h4 slot="header" class="title title-up modal-crm-title mb-0">
            Affectation commercial
          </h4>
          <p class="mb-3">
            <strong>{{ selectedRows.length }}</strong> contact(s) sélectionné(s)
          </p>
          <base-input label="Commercial">
            <el-select
              class="select-primary w-100"
              v-model="bulkCommercialId"
              placeholder="Choisir un commercial"
              clearable
              filterable
            >
              <el-option
                v-for="c in activeCommercials"
                :key="'b-' + c.id"
                :value="String(c.id)"
                :label="commercialLabel(c)"
              />
            </el-select>
          </base-input>
          <div slot="footer" class="w-100 text-right">
            <button
              type="button"
              class="btn btn-default"
              :disabled="!bulkCommercialId || bulkAssigning || !selectedRows.length"
              @click="bulkClearCommercial"
            >
              Retirer
            </button>
            <button
              type="button"
              class="btn btn-market"
              :disabled="!bulkCommercialId || bulkAssigning || !selectedRows.length"
              @click="bulkAssignCommercial"
            >
              Affecter
            </button>
          </div>
        </modal>

        <!-- Full fiche modal -->
        <modal
          :show.sync="fullFiche"
          body-classes="p-0"
          class="modal-crm modal-crm-full"
          :show-close="false"
        >
          <card class="border-0 mb-0" v-if="selectedLead">
            <div class="p-3">
              <contact-fiche
                full
                :lead="selectedLead"
                :crm="crmOf(selectedLead)"
                :commercials="commercials"
                :field-groups="selectedFieldGroups"
                :details-loading="detailsLoading"
                :mg-unavailable="detailsMgUnavailable"
                :mg-consent="detailsMgConsent"
                :state-saving="crmStateSaving"
                :comment-draft="commentDraft"
                :comment-saving="commentSaving"
                :show-tarification="tarificationCrmEnabled"
                @update:commentDraft="commentDraft = $event"
                @close="fullFiche = false"
                @open-call="callOpen = true"
                @open-sms="openSms"
                @update-state="updateCrmState"
                @add-comment="addComment"
              />
            </div>
          </card>
        </modal>

        <!-- Call modal -->
        <modal
          :show.sync="callOpen"
          class="modal-crm"
          body-classes="p-0"
          :show-close="false"
        >
          <card class="border-0 mb-0">
            <h4 slot="header" class="title title-up modal-crm-title">Logger un appel</h4>
            <base-input label="Résultat">
              <el-select class="select-primary w-100" v-model="callResult">
                <el-option v-for="r in callResults" :key="r" :value="r" :label="r" />
              </el-select>
            </base-input>
            <base-input label="Programmer un rappel">
              <el-date-picker
                class="w-100"
                v-model="callCallback"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="Optionnel"
              />
            </base-input>
            <div class="text-right mt-3">
              <button class="btn btn-default" @click="callOpen = false">Annuler</button>
              <button class="btn btn-market" @click="confirmCall">Confirmer</button>
            </div>
          </card>
        </modal>

        <!-- SMS modal — modèle suggéré copiable (pas d'envoi) -->
        <modal
          :show.sync="smsOpen"
          class="modal-crm"
          body-classes="p-0"
          :show-close="false"
        >
          <card class="border-0 mb-0">
            <h4 slot="header" class="title title-up modal-crm-title">Modèle SMS suggéré</h4>
            <p class="text-muted small mb-3">
              Service SMS non disponible. Copiez le modèle pour l’utiliser hors CRM.
            </p>
            <base-input label="Modèle">
              <el-select class="select-primary w-100" v-model="smsTpl" @change="onSmsTplChange">
                <el-option
                  v-for="t in smsTemplateList"
                  :key="t.key"
                  :value="t.key"
                  :label="t.label"
                />
              </el-select>
            </base-input>
            <base-input label="Message">
              <textarea class="form-control modal-crm-textarea" rows="5" v-model="smsBody" />
            </base-input>
            <div class="text-right mt-3">
              <button class="btn btn-default" @click="smsOpen = false">Annuler</button>
              <button class="btn btn-market" :disabled="!smsBody.trim()" @click="copySmsTemplate">
                Copier
              </button>
            </div>
          </card>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, DatePicker, Input } from 'element-ui'
import { Table, TableColumn } from 'element-ui'
import { BasePagination, BaseCheckbox, BaseDropdown, Modal, Card } from 'src/components'
import gql from 'graphql-tag'
import CrmKpis from './CrmKpis.vue'
import ContactFiche from './ContactFiche.vue'
import CommercialsPanel from './CommercialsPanel.vue'
import { Icons } from 'src/pages/Pages/MyMarketAdmin/Product_Icons'
import {
  CRM_STATUSES,
  CALL_RESULTS,
  MAX_CALLS,
  SMS_TEMPLATES,
  statusMeta,
  emptyCrmState,
  mergeDefinedCrmFields,
  currentUserLabel,
  currentClientSociety,
  commercialLabel,
  getStoredOperatorId,
  setStoredOperatorId,
  isSupervisorUser,
  buildFieldGroups,
  buildFieldGroupsFromMg,
  buildFieldGroupsFromMrh,
  mergeMgAndQqInputs,
  isAutoProduct,
  isMrhProduct,
  countFilledAttrs,
  isSameDay,
  todayIso,
  daysAgoIso,
  normalizePhone,
  prettyCallbackAt,
  callbackRelative,
  tarificationLabel,
  tarificationBadgeClass,
  isTarificationAutre,
  isTarificationCrmEnabled
} from './crmStatuses'

const today = new Date()

export default {
  name: 'MyLeadsV2',
  apollo: {
    MyLeads: {
      client: 'MARKET',
      query: require('src/graphql/leadmarket/Annonceur/MyLeads.gql'),
      variables() {
        return {
          id_utilisateur: JSON.parse(localStorage.getItem('utilisateur')).id,
          date_debut: this.StartDate,
          date_fin: this.EndnDate,
          produit: this.ProductSelects.Product,
          statut: this.StatutSelects.Statut,
          pack: this.PackSelects.Pack,
          facturation: this.FabricationSelects.Fabrication
        }
      },
      skip() {
        return this.SkipQuery
      },
      async result() {
        this.SkipQuery = true
        await this.loadCrmStates()
        await this.loadCommercials()
      },
      fetchPolicy: 'network-only',
      update: (data) => (data.leadsAnnonceur && data.leadsAnnonceur[0] && data.leadsAnnonceur[0].leads) || []
    },
    produits: {
      client: 'MARKET',
      query: gql`query {
        produits {
          pk_categorie
          designation
        }
      }`,
      result({ data }) {
        this.ProductSelects.ListProduct = data.produits || []
      }
    }
  },
  components: {
    BasePagination,
    BaseCheckbox,
    BaseDropdown,
    Modal,
    Card,
    CrmKpis,
    ContactFiche,
    CommercialsPanel,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Input.name]: Input
  },
  data() {
    return {
      With_fields: false,
      icons: Icons,
      SkipQuery: true,
      searchQuery: '',
      total: 0,
      StartDate: today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate(),
      EndnDate: today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate(),
      ProductSelects: { Product: '', ListProduct: [] },
      PackSelects: {
        Pack: '',
        ListPack: [
          { value: '', label: 'TOUS LES PACKS' },
          { value: 'exclusif', label: 'EXCLUSIF' },
          { value: 'duo', label: 'DUO' },
          { value: 'trio', label: 'TRIO' },
          { value: 'destockage', label: 'DESTOCKAGE' }
        ]
      },
      FabricationSelects: {
        Fabrication: '',
        ListFabrication: [
          { value: 'facturable', label: 'FACTURABLE' },
          { value: 'non facturable', label: 'NON FACTURABLE' }
        ]
      },
      StatutSelects: {
        Statut: '',
        ListStatut: [
          { value: '', label: 'TOUS LES STATUTS' },
          { value: 'ok', label: 'VALIDÉ' },
          { value: 'en cours de verification', label: 'EN COURS DE TRAITEMENT' },
          { value: 'devalide', label: 'DÉVALIDÉ' },
          { value: 'demande refusee', label: 'DEMANDE REFUSÉE' }
        ]
      },
      pagination: { perPage: 50, currentPage: 1, perPageOptions: [10, 25, 50, 100], total: 0 },
      MyLeads: [],
      rows: [
        { label: 'Date', show: true },
        { label: 'N° commande', show: false },
        { label: 'Ref', show: false },
        { label: 'Produit', show: true },
        { label: 'Gamme', show: false },
        { label: 'Contact', show: true },
        { label: 'Téléphone', show: false },
        { label: 'Code postal', show: true },
        { label: 'Email', show: false },
        { label: 'Facturation', show: false },
        { label: 'Date de collecte', show: false },
        { label: "Phrase d'optin", show: false },
        { label: 'Site du collecte', show: false },
        { label: "Consulter l'annuaire", show: false },
        { label: 'Statut du lead', show: true },
        { label: 'Demande de dévalidation', show: true },
        { label: 'Appels', show: true },
        { label: 'Statut CRM', show: true },
        { label: 'Commercial', show: true },
        { label: 'Pièces', show: true },
        { label: 'Rappel', show: true },
        { label: 'Tarification', show: true, heomiOnly: true }
      ],
      isAdmin: localStorage.getItem('user_origine_id') != null,
      isSupervisor: isSupervisorUser(),
      crmMap: {},
      crmLoading: false,
      crmStateSaving: false,
      crmUnavailable: false,
      crmStatusFilter: '',
      crmProductFilter: '',
      ageFilter: '',
      cpFilter: '',
      commercialFilter: '',
      rappelFilter: '',
      tarificationFilter: '',
      commercials: [],
      commercialSubmitting: false,
      localCommercialSeq: 1,
      operatorId: getStoredOperatorId(),
      selectedRows: [],
      bulkCommercialId: '',
      bulkAssigning: false,
      bulkAssignOpen: false,
      kpiFilter: '',
      selectedLead: null,
      fullFiche: false,
      ficheDockStyle: null,
      ficheSpacerPx: 480,
      detailsLoading: false,
      detailsMgUnavailable: false,
      detailsMgConsent: null,
      selectedFieldGroups: [],
      detailsCache: {},
      commentDraft: '',
      commentSaving: false,
      callOpen: false,
      callResult: CALL_RESULTS[0],
      callCallback: '',
      callResults: CALL_RESULTS,
      smsOpen: false,
      smsTpl: 'rdv',
      smsBody: '',
      crmStatuses: CRM_STATUSES,
      maxCalls: MAX_CALLS
    }
  },
  computed: {
    tarificationCrmEnabled() {
      return isTarificationCrmEnabled(this.userId())
    },
    smsTemplateList() {
      return Object.values(SMS_TEMPLATES)
    },
    activeCommercials() {
      return (this.commercials || []).filter((c) => c.status !== 'disabled')
    },
    enrichedLeads() {
      return (this.MyLeads || []).map((l) => ({
        ...l,
        _crm: this.crmOf(l)
      }))
    },
    filteredByCrm() {
      let list = this.enrichedLeads
      if (this.crmProductFilter) {
        list = list.filter((l) => String(l.pk_categorie) === String(this.crmProductFilter))
      }
      if (this.kpiFilter === 'a_traiter') {
        list = list.filter((l) => l._crm.status === 'A_TRAITER')
      } else if (this.kpiFilter === 'traites') {
        list = list.filter((l) => l._crm.status !== 'A_TRAITER')
      } else if (this.kpiFilter === 'contrat') {
        list = list.filter((l) => l._crm.status === 'CONTRAT_REALISE')
      }
      if (this.crmStatusFilter === '__4_CALLS__') {
        list = list.filter((l) => (l._crm.calls_count || 0) >= MAX_CALLS)
      } else if (this.crmStatusFilter) {
        list = list.filter((l) => l._crm.status === this.crmStatusFilter)
      }
      if (this.commercialFilter === '__UNASSIGNED__') {
        list = list.filter((l) => !l._crm.owner_commercial_id)
      } else if (this.commercialFilter) {
        list = list.filter((l) => String(l._crm.owner_commercial_id) === String(this.commercialFilter))
      }
      if (this.ageFilter === 'under21') {
        list = list.filter((l) => {
          const age = this.ageFromBirthDate(l.date_naissance)
          return age !== null && age < 21
        })
      } else if (this.ageFilter === 'over21') {
        list = list.filter((l) => {
          const age = this.ageFromBirthDate(l.date_naissance)
          return age !== null && age > 21
        })
      }
      const cpQ = String(this.cpFilter || '').trim()
      if (cpQ) {
        list = list.filter((l) => String(l.cp || '').startsWith(cpQ))
      }
      const rappelMode = this.rappelFilter || (this.kpiFilter === 'rappels' ? 'today' : '')
      if (rappelMode === 'today') {
        const day = todayIso()
        list = list.filter((l) => isSameDay(l._crm.callback_at, day))
      } else if (rappelMode === 'upcoming') {
        list = list.filter((l) => callbackRelative(l._crm.callback_at) === 'upcoming')
      } else if (rappelMode === 'overdue') {
        list = list.filter((l) => callbackRelative(l._crm.callback_at) === 'overdue')
      }
      if (this.tarificationCrmEnabled && this.tarificationFilter) {
        list = list.filter(
          (l) => Number(l.pk_categorie) === 2 && l.auto_segment === this.tarificationFilter
        )
      }
      return list
    },
    filterlistMylead() {
      let list = []
      try {
        const q = (this.searchQuery || '').toLocaleLowerCase().trim()
        const qPhone = normalizePhone(q)
        list = this.filteredByCrm.filter((lead) => {
          if (!q) return true
          const crm = lead._crm || {}
          const statusLabel = (statusMeta(crm.status).label || '').toLocaleLowerCase()
          const commercial = String(crm.owner_commercial_name || '').toLocaleLowerCase()
          const tarif = this.tarificationCrmEnabled
            ? String(tarificationLabel(lead) || '').toLocaleLowerCase()
            : ''
          const tel = String(lead.telephone || '')
          return (
            String(lead.date_livraison || '').match(this.searchQuery) ||
            String(lead.pk_bon_commande || '').match(this.searchQuery) ||
            String(lead.pk_lead || '').match(this.searchQuery) ||
            String(lead.categorie || '').toLocaleLowerCase().includes(q) ||
            String(lead.pack || '').toLocaleLowerCase().includes(q) ||
            (String(lead.nom || '') + ' ' + String(lead.prenom || '')).toLocaleLowerCase().includes(q) ||
            tel.toLocaleLowerCase().includes(q) ||
            (qPhone && normalizePhone(tel).includes(qPhone)) ||
            String(lead.cp || '').match(this.searchQuery) ||
            String(lead.email || '').toLocaleLowerCase().includes(q) ||
            String(lead.date_collecte || '').match(this.searchQuery) ||
            String(lead.phrase_optin || '').toLocaleLowerCase().includes(q) ||
            String(lead.site_collecte || '').toLocaleLowerCase().includes(q) ||
            statusLabel.includes(q) ||
            commercial.includes(q) ||
            (tarif && tarif.includes(q))
          )
        })
        this.total = list.length
        return list.slice(this.from, this.to)
      } catch (error) {
        console.log(error)
        return []
      }
    },
    activeFilterChips() {
      const chips = []
      const q = String(this.searchQuery || '').trim()
      if (q) chips.push({ key: 'search', label: '« ' + q + ' »' })
      if (this.crmProductFilter) {
        const p = (this.ProductSelects.ListProduct || []).find(
          (x) => String(x.pk_categorie) === String(this.crmProductFilter)
        )
        chips.push({
          key: 'product',
          label: 'Produit : ' + ((p && p.designation) ? p.designation.replace(/Ã©/g, 'é').toUpperCase() : this.crmProductFilter)
        })
      }
      if (this.crmStatusFilter === '__4_CALLS__') {
        chips.push({ key: 'crmStatus', label: 'Statut : 4 appels atteints' })
      } else if (this.crmStatusFilter) {
        chips.push({
          key: 'crmStatus',
          label: 'Statut : ' + statusMeta(this.crmStatusFilter).label
        })
      }
      if (this.commercialFilter === '__UNASSIGNED__') {
        chips.push({ key: 'commercial', label: 'Commercial : Non affecté' })
      } else if (this.commercialFilter) {
        const c = (this.commercials || []).find((x) => String(x.id) === String(this.commercialFilter))
        chips.push({
          key: 'commercial',
          label: 'Commercial : ' + (c ? commercialLabel(c) : this.commercialFilter)
        })
      }
      if (this.rappelFilter === 'today' || this.kpiFilter === 'rappels') {
        chips.push({ key: 'rappel', label: 'Rappel : du jour' })
      } else if (this.rappelFilter === 'upcoming') {
        chips.push({ key: 'rappel', label: 'Rappel : à venir' })
      } else if (this.rappelFilter === 'overdue') {
        chips.push({ key: 'rappel', label: 'Rappel : en retard' })
      }
      if (this.tarificationCrmEnabled && this.tarificationFilter === 'bons_conducteurs') {
        chips.push({ key: 'tarification', label: 'Tarification Coverity' })
      } else if (this.tarificationCrmEnabled && this.tarificationFilter === 'auto_rag') {
        chips.push({ key: 'tarification', label: 'Tarification autre' })
      }
      if (this.ageFilter === 'under21') chips.push({ key: 'age', label: 'Âge : < 21 ans' })
      if (this.ageFilter === 'over21') chips.push({ key: 'age', label: 'Âge : > 21 ans' })
      const cp = String(this.cpFilter || '').trim()
      if (cp) chips.push({ key: 'cp', label: 'CP : ' + cp })
      if (this.kpiFilter === 'a_traiter') chips.push({ key: 'kpi', label: 'KPI : À traiter' })
      if (this.kpiFilter === 'traites') chips.push({ key: 'kpi', label: 'KPI : Traités' })
      if (this.kpiFilter === 'contrat') chips.push({ key: 'kpi', label: 'KPI : Contrats' })
      return chips
    },
    to() {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) highBound = this.total
      return highBound
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    kpiItems() {
      const all = this.enrichedLeads
      const day = todayIso()
      const aTraiter = all.filter((l) => l._crm.status === 'A_TRAITER').length
      const rappels = all.filter((l) => isSameDay(l._crm.callback_at, day)).length
      const traites = all.filter((l) => l._crm.status !== 'A_TRAITER').length
      const contrats = all.filter((l) => l._crm.status === 'CONTRAT_REALISE').length
      const stock = all.length || 1
      return [
        { key: 'a_traiter', label: 'À traiter', value: aTraiter },
        { key: 'rappels', label: 'Rappels du jour', value: rappels },
        {
          key: 'traites',
          label: 'Traités / stock',
          value: traites + ' / ' + all.length,
          sub: Math.round((traites / stock) * 100) + ' %'
        },
        {
          key: 'contrat',
          label: 'Transformation',
          value: contrats,
          sub: Math.round((contrats / stock) * 100) + ' %'
        }
      ]
    }
  },
  methods: {
    statusMeta,
    commercialLabel,
    prettyCallbackAt,
    callbackRelative,
    tarificationLabel,
    tarificationBadgeClass,
    productLabel(categorie) {
      return String(categorie || '').replace(/Ã©/g, 'é').toUpperCase()
    },
    productIconClass(categorie) {
      const name = String(categorie || '').replace(/Ã©/g, 'é')
      return this.icons[name] || this.icons[name.toUpperCase()] || 'fas fa-tag'
    },
    actorLabel() {
      if (this.operatorId) {
        const c = (this.commercials || []).find((x) => String(x.id) === String(this.operatorId))
        if (c) return commercialLabel(c)
      }
      return currentUserLabel()
    },
    onOperatorChange(id) {
      setStoredOperatorId(id)
      if (id) {
        this.commercialFilter = String(id)
        this.pagination.currentPage = 1
      }
    },
    onSelectionChange(rows) {
      this.selectedRows = rows || []
      if (!this.selectedRows.length) {
        this.bulkAssignOpen = false
        this.bulkCommercialId = ''
      }
    },
    crmOf(lead) {
      if (!lead) return emptyCrmState(null)
      const id = String(lead.pk_lead)
      return this.crmMap[id] || emptyCrmState(lead.pk_lead)
    },
    setCrm(pkLead, state) {
      this.$set(this.crmMap, String(pkLead), {
        ...emptyCrmState(pkLead),
        ...state,
        pk_lead: pkLead
      })
      // Force recomputation of filters / KPIs / table badges / fiche
      this.crmMap = Object.assign({}, this.crmMap)
      this.restoreTableSelection()
    },
    /** Remplace l’état CRM d’un lead en préservant les listes non renvoyées par l’API */
    applyCrmStatePatch(pkLead, patch, { replaceCalls, replaceSms, replaceComments } = {}) {
      const prev = this.crmOf({ pk_lead: pkLead })
      const next = mergeDefinedCrmFields(prev, patch || {})
      if (replaceCalls && Array.isArray(patch.calls)) next.calls = patch.calls
      else if (!Array.isArray(patch && patch.calls)) next.calls = prev.calls || []
      if (replaceSms && Array.isArray(patch.sms)) next.sms = patch.sms
      else if (!Array.isArray(patch && patch.sms)) next.sms = prev.sms || []
      if (replaceComments && Array.isArray(patch.comments)) next.comments = patch.comments
      else if (!Array.isArray(patch && patch.comments)) next.comments = prev.comments || []
      if (patch && patch.calls_count != null) next.calls_count = patch.calls_count
      else if (Array.isArray(next.calls)) next.calls_count = next.calls.length
      this.setCrm(pkLead, next)
    },
    appendCrmList(pkLead, listKey, entry) {
      if (!entry) return
      const prev = this.crmOf({ pk_lead: pkLead })
      const list = [...(prev[listKey] || [])]
      const id = entry.id != null ? String(entry.id) : null
      if (id && list.some((x) => x && String(x.id) === id)) {
        this.setCrm(pkLead, {
          ...prev,
          [listKey]: list.map((x) => (String(x.id) === id ? { ...x, ...entry } : x)),
          calls_count: listKey === 'calls' ? list.length : prev.calls_count
        })
        return
      }
      list.push(entry)
      const next = { ...prev, [listKey]: list }
      if (listKey === 'calls') next.calls_count = list.length
      this.setCrm(pkLead, next)
    },
    restoreTableSelection() {
      if (!this.selectedLead) return
      const pk = String(this.selectedLead.pk_lead)
      this.$nextTick(() => {
        const table = this.$refs.leadsTable
        if (!table || typeof table.setCurrentRow !== 'function') return
        const row = (this.filterlistMylead || []).find((r) => String(r.pk_lead) === pk)
        if (row) {
          table.setCurrentRow(row)
        }
      })
    },
    mergeCrmApiState(pk, apiState) {
      if (!apiState) return
      this.applyCrmStatePatch(pk, apiState, {
        replaceCalls: Array.isArray(apiState.calls),
        replaceSms: Array.isArray(apiState.sms),
        replaceComments: Array.isArray(apiState.comments)
      })
    },
    nowSql() {
      return new Date().toISOString().slice(0, 19).replace('T', ' ')
    },
    /**
     * logCrmCall renvoie un CrmLeadState (avec calls[]), pas un CrmCall.
     * On synchronise immédiatement l’UI avec la réponse API.
     */
    applyLogCrmCallResponse(pk, state, by) {
      const prev = this.crmOf({ pk_lead: pk })
      if (!state) {
        this.applyLocalCall(pk, by)
        return
      }
      // Remplacer la liste seulement si l’API renvoie des appels utiles
      if (Array.isArray(state.calls) && state.calls.length) {
        this.applyCrmStatePatch(pk, state, { replaceCalls: true })
        return
      }
      // API sans nested calls (ou liste vide) : garder l’optimiste + patch status/count
      const calls = prev.calls || []
      this.setCrm(pk, {
        ...prev,
        status: state.status != null && state.status !== '' ? state.status : prev.status,
        callback_at:
          state.callback_at !== undefined && state.callback_at !== null
            ? state.callback_at
            : prev.callback_at,
        calls,
        calls_count:
          state.calls_count != null
            ? state.calls_count
            : calls.length || prev.calls_count || 0
      })
    },
    dotClass(count, n) {
      if (n > (count || 0)) return 'text-muted'
      if ((count || 0) >= 4) return 'text-danger'
      return 'text-warning'
    },
    piecesCollectedCount(crm) {
      let n = 0
      if (crm && crm.piece_carte_grise) n += 1
      if (crm && crm.piece_permis) n += 1
      if (crm && crm.piece_releve) n += 1
      return n
    },
    resolveCommercialName(id) {
      if (!id) return null
      const c = (this.commercials || []).find((x) => String(x.id) === String(id))
      return c ? commercialLabel(c) : null
    },
    userId() {
      return JSON.parse(localStorage.getItem('utilisateur')).id
    },
    async loadCommercials() {
      try {
        const { data } = await this.$apollo.query({
          client: 'MARKET',
          query: require('src/graphql/leadmarket/Annonceur/crm/crmCommercials.gql'),
          variables: { id_utilisateur: this.userId() },
          fetchPolicy: 'network-only'
        })
        this.commercials = (data && data.crmCommercials) || []
      } catch (e) {
        console.warn('crmCommercials unavailable', e)
        // keep local list if any
      }
      // Drop stale operator if commercial removed/disabled
      if (this.operatorId) {
        const still = (this.commercials || []).some(
          (c) => String(c.id) === String(this.operatorId) && c.status !== 'disabled'
        )
        if (!still) {
          this.operatorId = ''
          setStoredOperatorId('')
        }
      }
    },
    async onCreateCommercial(form) {
      this.commercialSubmitting = true
      const payload = {
        prenom: (form.prenom || '').trim(),
        nom: (form.nom || '').trim(),
        email: (form.email || '').trim() || null,
        telephone: (form.telephone || '').trim() || null
      }
      try {
        const { data } = await this.$apollo.mutate({
          client: 'MARKET',
          mutation: require('src/graphql/leadmarket/Annonceur/crm/createCrmCommercial.gql'),
          variables: {
            id_utilisateur: this.userId(),
            ...payload
          }
        })
        if (data && data.createCrmCommercial) {
          this.commercials = [data.createCrmCommercial, ...this.commercials]
          this.$notify({ type: 'success', message: 'Commercial ajouté' })
        }
      } catch (e) {
        const local = {
          id: 'local-com-' + this.localCommercialSeq++,
          id_utilisateur: this.userId(),
          ...payload,
          email: payload.email || '',
          status: 'active'
        }
        this.commercials = [local, ...this.commercials]
        this.$notify({
          type: 'warning',
          message: 'Commercial ajouté en local (API createCrmCommercial indisponible)'
        })
        console.warn('createCrmCommercial failed', e)
      } finally {
        this.commercialSubmitting = false
      }
    },
    async onDisableCommercial(c) {
      await this.setCommercialStatus(c, 'disabled')
    },
    async onEnableCommercial(c) {
      await this.setCommercialStatus(c, 'active')
    },
    async setCommercialStatus(c, status) {
      if (!c) return
      this.commercialSubmitting = true
      try {
        const { data } = await this.$apollo.mutate({
          client: 'MARKET',
          mutation: require('src/graphql/leadmarket/Annonceur/crm/updateCrmCommercial.gql'),
          variables: {
            id_utilisateur: this.userId(),
            id: c.id,
            status
          }
        })
        const updated = data && data.updateCrmCommercial
        if (updated) {
          this.commercials = (this.commercials || []).map((x) =>
            String(x.id) === String(updated.id) ? updated : x
          )
        } else {
          this.commercials = (this.commercials || []).map((x) =>
            String(x.id) === String(c.id) ? { ...x, status } : x
          )
        }
        if (status === 'disabled' && String(this.operatorId) === String(c.id)) {
          this.operatorId = ''
          setStoredOperatorId('')
          if (String(this.commercialFilter) === String(c.id)) this.commercialFilter = ''
        }
        this.$notify({
          type: 'success',
          message: status === 'disabled' ? 'Commercial désactivé' : 'Commercial réactivé'
        })
      } catch (e) {
        this.commercials = (this.commercials || []).map((x) =>
          String(x.id) === String(c.id) ? { ...x, status } : x
        )
        if (status === 'disabled' && String(this.operatorId) === String(c.id)) {
          this.operatorId = ''
          setStoredOperatorId('')
        }
        this.$notify({
          type: 'warning',
          message: 'Statut commercial mis à jour en local (API indisponible)'
        })
        console.warn('updateCrmCommercial failed', e)
      } finally {
        this.commercialSubmitting = false
      }
    },
    async bulkAssignCommercial() {
      if (!this.bulkCommercialId || !this.selectedRows.length) return
      const id = this.bulkCommercialId
      const name = this.resolveCommercialName(id)
      const ok = await this.bulkAssignCrmCommercialRequest({
        owner_commercial_id: id,
        clear_commercial: false
      })
      if (ok > 0) {
        this.bulkAssignOpen = false
        this.$notify({
          type: 'success',
          message: ok + ' contact(s) affecté(s) à ' + (name || id)
        })
      }
    },
    async bulkClearCommercial() {
      if (!this.bulkCommercialId || !this.selectedRows.length) return
      const ok = await this.bulkAssignCrmCommercialRequest({
        owner_commercial_id: null,
        clear_commercial: true
      })
      if (ok > 0) {
        this.bulkAssignOpen = false
        this.$notify({ type: 'success', message: ok + ' affectation(s) retirée(s)' })
      }
    },
    /**
     * Une seule requête GraphQL pour lier / délier N contacts à un commercial.
     * Mutation: bulkAssignCrmCommercial(pk_leads, owner_commercial_id, clear_commercial)
     */
    async bulkAssignCrmCommercialRequest({ owner_commercial_id, clear_commercial }) {
      const rows = this.selectedRows.slice()
      if (!rows.length) return 0
      this.bulkAssigning = true
      const by = this.actorLabel()
      const pkLeads = rows.map((r) => r.pk_lead)
      const prevByPk = {}
      rows.forEach((row) => {
        const pk = String(row.pk_lead)
        prevByPk[pk] = { ...this.crmOf(row) }
        const next = { ...prevByPk[pk] }
        if (clear_commercial) {
          next.owner_commercial_id = null
          next.owner_commercial_name = null
        } else {
          next.owner_commercial_id = owner_commercial_id
          next.owner_commercial_name = this.resolveCommercialName(owner_commercial_id)
        }
        this.setCrm(pk, next)
      })
      try {
        if (!this.crmUnavailable) {
          const { data } = await this.$apollo.mutate({
            client: 'MARKET',
            mutation: require('src/graphql/leadmarket/Annonceur/crm/bulkAssignCrmCommercial.gql'),
            variables: {
              id_utilisateur: this.userId(),
              pk_leads: pkLeads,
              owner_commercial_id: clear_commercial ? null : owner_commercial_id,
              clear_commercial: clear_commercial === true,
              updated_by: by
            }
          })
          const states = (data && data.bulkAssignCrmCommercial) || []
          states.forEach((s) => {
            if (!s || s.pk_lead == null) return
            this.mergeCrmApiState(s.pk_lead, s)
            const confirmed = { ...this.crmOf({ pk_lead: s.pk_lead }) }
            if (clear_commercial) {
              confirmed.owner_commercial_id = null
              confirmed.owner_commercial_name = null
            } else if (owner_commercial_id != null) {
              confirmed.owner_commercial_id = owner_commercial_id
              confirmed.owner_commercial_name = this.resolveCommercialName(owner_commercial_id)
            }
            this.setCrm(s.pk_lead, confirmed)
          })
        }
        return pkLeads.length
      } catch (e) {
        Object.keys(prevByPk).forEach((pk) => this.setCrm(pk, prevByPk[pk]))
        console.warn('bulkAssignCrmCommercial failed', e)
        this.$notify({
          type: 'danger',
          message:
            'Échec affectation groupée — vérifier la mutation API bulkAssignCrmCommercial'
        })
        return 0
      } finally {
        this.bulkAssigning = false
        this.clearTableSelection()
        this.scheduleFicheDock()
      }
    },
    clearTableSelection() {
      this.selectedRows = []
      this.bulkCommercialId = ''
      this.bulkAssignOpen = false
      this.$nextTick(() => {
        const table = this.$refs.leadsTable
        if (table && typeof table.clearSelection === 'function') table.clearSelection()
      })
    },
    async loadCrmStates() {
      const leads = this.MyLeads || []
      if (!leads.length) return
      this.crmLoading = true
      try {
        const { data } = await this.$apollo.query({
          client: 'MARKET',
          query: require('src/graphql/leadmarket/Annonceur/crm/crmStatesByLeads.gql'),
          variables: {
            id_utilisateur: this.userId(),
            pk_leads: leads.map((l) => l.pk_lead)
          },
          fetchPolicy: 'network-only'
        })
        const states = (data && data.crmStatesByLeads) || []
        const map = {}
        leads.forEach((l) => {
          map[String(l.pk_lead)] = emptyCrmState(l.pk_lead)
        })
        states.forEach((s) => {
          const pk = String(s.pk_lead)
          const base = map[pk] || emptyCrmState(s.pk_lead)
          const merged = mergeDefinedCrmFields(base, s)
          merged.piece_carte_grise = s.piece_carte_grise != null ? !!s.piece_carte_grise : base.piece_carte_grise
          merged.piece_permis = s.piece_permis != null ? !!s.piece_permis : base.piece_permis
          merged.piece_releve = s.piece_releve != null ? !!s.piece_releve : base.piece_releve
          if (s.calls) merged.calls = s.calls
          if (s.sms) merged.sms = s.sms
          if (s.comments) merged.comments = s.comments
          merged.calls_count =
            s.calls_count != null ? s.calls_count : (merged.calls || []).length
          // Explicit status only if API sent a real value — never wipe with null
          if (s.status != null && s.status !== '') {
            merged.status = s.status
          }
          map[pk] = merged
        })
        this.crmMap = map
        this.crmUnavailable = false
      } catch (e) {
        console.warn('CRM overlay API unavailable — defaults applied', e)
        this.crmUnavailable = true
        const map = {}
        leads.forEach((l) => {
          map[String(l.pk_lead)] = emptyCrmState(l.pk_lead)
        })
        this.crmMap = map
      } finally {
        this.crmLoading = false
      }
    },
    onKpiFilter(key) {
      const wasRappels = this.kpiFilter === 'rappels'
      const next = this.kpiFilter === key ? '' : key
      this.kpiFilter = next
      if (next === 'rappels') {
        this.rappelFilter = 'today'
      } else if (wasRappels) {
        this.rappelFilter = ''
      }
      this.pagination.currentPage = 1
    },
    onRappelFilterChange() {
      if (this.rappelFilter === 'today') {
        this.kpiFilter = 'rappels'
      } else if (this.kpiFilter === 'rappels') {
        this.kpiFilter = ''
      }
      this.pagination.currentPage = 1
    },
    clearFilter(key) {
      if (key === 'search') this.searchQuery = ''
      else if (key === 'product') this.crmProductFilter = ''
      else if (key === 'crmStatus') this.crmStatusFilter = ''
      else if (key === 'commercial') this.commercialFilter = ''
      else if (key === 'rappel') {
        this.rappelFilter = ''
        if (this.kpiFilter === 'rappels') this.kpiFilter = ''
      } else if (key === 'tarification') this.tarificationFilter = ''
      else if (key === 'age') this.ageFilter = ''
      else if (key === 'cp') this.cpFilter = ''
      else if (key === 'kpi') {
        if (this.kpiFilter === 'rappels') this.rappelFilter = ''
        this.kpiFilter = ''
      }
      this.pagination.currentPage = 1
    },
    clearAllTableFilters() {
      this.searchQuery = ''
      this.crmProductFilter = ''
      this.crmStatusFilter = ''
      this.commercialFilter = ''
      this.rappelFilter = ''
      this.tarificationFilter = ''
      this.ageFilter = ''
      this.cpFilter = ''
      this.kpiFilter = ''
      this.pagination.currentPage = 1
    },
    applyDatePreset(preset) {
      const today = todayIso()
      if (preset === 'today' || preset === 0) {
        this.StartDate = today
        this.EndnDate = today
      } else if (preset === 'yesterday') {
        const y = daysAgoIso(1)
        this.StartDate = y
        this.EndnDate = y
      } else {
        this.StartDate = daysAgoIso(preset)
        this.EndnDate = today
      }
      this.search()
    },
    onCrmFilterKeydown(e) {
      const tag = (e.target && e.target.tagName) || ''
      const typing =
        tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (e.target && e.target.isContentEditable)
      if ((e.key === '/' || (e.key === 'k' && (e.ctrlKey || e.metaKey))) && !typing) {
        e.preventDefault()
        this.focusCrmSearch()
        return
      }
      if (e.key === 'Escape') {
        const el = document.getElementById('crm-search-input')
        const active = document.activeElement
        const inSearch =
          (el && (active === el || (el.contains && el.contains(active)))) ||
          (active && active.classList && active.classList.contains('crm-search-input'))
        if (inSearch || (active && active.closest && active.closest('.crm-search-wrap'))) {
          this.searchQuery = ''
        }
      }
    },
    focusCrmSearch() {
      this.$nextTick(() => {
        const root = this.$refs.crmSearchInput
        if (root && root.$el) {
          const input = root.$el.querySelector('input')
          if (input) input.focus()
        } else {
          const el = document.getElementById('crm-search-input')
          if (el) el.focus()
        }
      })
    },
    tarificationRowClassName({ row }) {
      if (!this.tarificationCrmEnabled) return ''
      return isTarificationAutre(row) ? 'crm-row-tarification-autre' : ''
    },
    graphqlErrorMessage(err) {
      const g0 = err && err.graphQLErrors && err.graphQLErrors[0]
      if (g0) {
        const code = g0.extensions && g0.extensions.code
        return String(g0.message || code || '')
      }
      if (err && err.message) return String(err.message)
      return ''
    },
    async onRowClick(row) {
      this.selectedLead = row
      this.fullFiche = false
      this.commentDraft = ''
      this.$nextTick(() => {
        const table = this.$refs.leadsTable
        if (table && typeof table.setCurrentRow === 'function') {
          table.setCurrentRow(row)
        }
        this.updateFicheDock()
      })
      await this.loadLeadDetails(row)
      this.scheduleFicheDock()
    },
    async openFullFiche(row) {
      this.selectedLead = row
      this.fullFiche = true
      this.commentDraft = ''
      this.ficheDockStyle = null
      this.$nextTick(() => {
        const table = this.$refs.leadsTable
        if (table && typeof table.setCurrentRow === 'function') {
          table.setCurrentRow(row)
        }
      })
      await this.loadLeadDetails(row)
    },
    isAutoProduct,
    packIdFromLead(lead) {
      const p = String((lead && lead.pack) || '').toLowerCase()
      if (p === 'exclusif') return 1
      if (p === 'duo') return 2
      if (p === 'trio') return 3
      if (p === 'destockage') return 1
      return 1
    },
    async loadLeadDetails(lead) {
      if (!lead) return
      const cacheKey = String(lead.pk_lead)
      if (this.detailsCache[cacheKey]) {
        const cached = this.detailsCache[cacheKey]
        this.selectedFieldGroups = cached.groups || cached
        this.detailsMgUnavailable = !!cached.mgUnavailable
        this.detailsMgConsent = cached.mgConsent || null
        return
      }
      this.detailsLoading = true
      this.detailsMgUnavailable = false
      this.detailsMgConsent = null
      const autoHint = isAutoProduct(lead, [])
      const mrhHint = isMrhProduct(lead)
      this.selectedFieldGroups = buildFieldGroups(lead, [], autoHint)
      try {
        if (!autoHint && !mrhHint) {
          const { data } = await this.$apollo.query({
            client: 'MARKET',
            query: require('src/graphql/leadmarket/Annonceur/showDetailsLead.gql'),
            variables: {
              id_utilisateur: this.userId(),
              lead_id: lead.pk_lead,
              pack_id: this.packIdFromLead(lead)
            },
            fetchPolicy: 'network-only'
          })
          const details = data && data.showDetailsLead
          const inputs = (details && details.inputs) || []
          const groups = buildFieldGroups(lead, inputs, false)
          this.detailsCache[cacheKey] = { groups, mgUnavailable: false, mgConsent: null }
          this.selectedFieldGroups = groups
          this.detailsMgUnavailable = false
          this.detailsMgConsent = null
          return
        }

        // AUTO / MRH: showDetailsLead (QQ) + showDetailsLead{Auto|Mrh}Mg (MonGustave) in parallel
        const mgField = mrhHint ? 'showDetailsLeadMrhMg' : 'showDetailsLeadAutoMg'
        const mgQuery = mrhHint
          ? require('src/graphql/leadmarket/Annonceur/crm/showDetailsLeadMrhMg.gql')
          : require('src/graphql/leadmarket/Annonceur/crm/showDetailsLeadAutoMg.gql')
        const qqPromise = this.$apollo.query({
          client: 'MARKET',
          query: require('src/graphql/leadmarket/Annonceur/showDetailsLead.gql'),
          variables: {
            id_utilisateur: this.userId(),
            lead_id: lead.pk_lead,
            pack_id: this.packIdFromLead(lead)
          },
          fetchPolicy: 'network-only'
        })
        const mgPromise = this.$apollo
          .query({
            client: 'MARKET',
            query: mgQuery,
            variables: {
              id_utilisateur: this.userId(),
              lead_id: lead.pk_lead
            },
            fetchPolicy: 'network-only'
          })
          .catch((e) => {
            console.warn('[mesLeadsV2] ' + mgField + ' failed', e)
            return null
          })

        const [qqRes, mgRes] = await Promise.all([qqPromise, mgPromise])
        const qqInputs =
          (qqRes && qqRes.data && qqRes.data.showDetailsLead && qqRes.data.showDetailsLead.inputs) ||
          []
        const mgPayload = mgRes && mgRes.data && mgRes.data[mgField] ? mgRes.data[mgField] : null
        const mgInputs = (mgPayload && mgPayload.inputs) || []
        const mgOk = !!(mgPayload && mgPayload.found && mgInputs.length)
        // Consentement LeadMarket : toujours renvoyé par MG (même si found=false)
        const mgConsent = mgPayload
          ? {
              phrase_optin: mgPayload.phrase_optin,
              site_collecte: mgPayload.site_collecte
            }
          : null

        let groups
        let mgUnavailable = false
        if (mrhHint) {
          groups = mgOk
            ? buildFieldGroupsFromMrh(lead, mgInputs, mgConsent)
            : buildFieldGroups(lead, qqInputs, false, mgConsent)
          mgUnavailable = !mgOk
        } else if (mgOk) {
          // MG prioritaire, mais on récupère les champs QQ manquants (marque/modèle…)
          const mergedInputs = mergeMgAndQqInputs(mgInputs, qqInputs)
          groups = buildFieldGroupsFromMg(lead, mergedInputs, mgConsent)
          mgUnavailable = false
        } else {
          groups = buildFieldGroups(lead, qqInputs, true, mgConsent)
          mgUnavailable = true
          if (countFilledAttrs(groups) <= 8) {
            console.warn(
              '[mesLeadsV2] Fiche auto peu remplie (' +
                countFilledAttrs(groups) +
                ' champs). MonGustave indisponible — fallback QQ.'
            )
          }
        }
        this.detailsCache[cacheKey] = { groups, mgUnavailable, mgConsent }
        this.selectedFieldGroups = groups
        this.detailsMgUnavailable = mgUnavailable
        this.detailsMgConsent = mgConsent
      } catch (e) {
        console.log(e)
        this.selectedFieldGroups = buildFieldGroups(lead, [], isAutoProduct(lead, []))
        this.detailsMgUnavailable = !!(autoHint || mrhHint)
        this.detailsMgConsent = null
      } finally {
        this.detailsLoading = false
      }
    },
    openSms() {
      if (!this.selectedLead) return
      const crm = this.crmOf(this.selectedLead)
      this.smsTpl = (crm.calls_count || 0) >= MAX_CALLS ? 'join' : 'rdv'
      this.onSmsTplChange()
      this.smsOpen = true
    },
    onSmsTplChange() {
      const tpl = SMS_TEMPLATES[this.smsTpl] || SMS_TEMPLATES.rdv
      const me = this.actorLabel()
      this.smsBody = tpl.body(
        this.selectedLead && this.selectedLead.prenom,
        me,
        currentClientSociety()
      )
    },
    ageFromBirthDate(dateNaissance) {
      if (!dateNaissance) return null
      const m = String(dateNaissance).trim().match(/^(\d{4})-(\d{2})-(\d{2})/)
      if (!m) return null
      const birth = new Date(+m[1], +m[2] - 1, +m[3])
      if (Number.isNaN(birth.getTime())) return null
      const now = new Date()
      let age = now.getFullYear() - birth.getFullYear()
      const md = now.getMonth() - birth.getMonth()
      if (md < 0 || (md === 0 && now.getDate() < birth.getDate())) age -= 1
      return age
    },
    copySmsTemplate() {
      const text = (this.smsBody || '').trim()
      if (!text || !this.selectedLead) return
      const pk = this.selectedLead.pk_lead
      const by = this.actorLabel()
      const templateKey = this.smsTpl || null
      const doneCopy = () => {
        this.$notify({ type: 'success', message: 'Modèle copié' })
        this.smsOpen = false
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(doneCopy).catch(() => {
          this.fallbackCopyText(text)
          doneCopy()
        })
      } else {
        this.fallbackCopyText(text)
        doneCopy()
      }
      // Historise le SMS immédiatement (comme un log) — sync UI sans reload
      this.persistSmsLog(pk, text, templateKey, by)
    },
    async persistSmsLog(pk, body, templateKey, by) {
      const localEntry = {
        id: 'local-sms-' + Date.now(),
        template_key: templateKey,
        body,
        created_at: this.nowSql(),
        created_by: by
      }
      // Optimistic
      this.appendCrmList(pk, 'sms', localEntry)
      try {
        if (this.crmUnavailable) return
        const { data } = await this.$apollo.mutate({
          client: 'MARKET',
          mutation: require('src/graphql/leadmarket/Annonceur/crm/logCrmSms.gql'),
          variables: {
            id_utilisateur: this.userId(),
            pk_lead: pk,
            body,
            template_key: templateKey,
            created_by: by
          }
        })
        if (data && data.logCrmSms) {
          const prev = this.crmOf({ pk_lead: pk })
          const sms = (prev.sms || []).map((s) =>
            String(s.id) === String(localEntry.id) ? { ...localEntry, ...data.logCrmSms } : s
          )
          // Si le local n’a pas été trouvé (race), append API entry
          const hasApi = sms.some((s) => String(s.id) === String(data.logCrmSms.id))
          this.setCrm(pk, {
            ...prev,
            sms: hasApi ? sms : [...sms.filter((s) => String(s.id) !== String(localEntry.id)), data.logCrmSms]
          })
        }
      } catch (e) {
        console.warn('logCrmSms failed — keep local SMS entry', e)
      }
    },
    fallbackCopyText(text) {
      const area = document.createElement('textarea')
      area.value = text
      area.style.position = 'fixed'
      area.style.left = '-9999px'
      document.body.appendChild(area)
      area.select()
      document.execCommand('copy')
      area.remove()
    },
    async confirmCall() {
      if (!this.selectedLead) return
      const crm = this.crmOf(this.selectedLead)
      if ((crm.calls_count || 0) >= MAX_CALLS) {
        this.$notify({ type: 'warning', message: 'Limite de 4 sollicitations atteinte — utilisez un modèle SMS.' })
        this.callOpen = false
        this.openSms()
        return
      }
      const pk = this.selectedLead.pk_lead
      const by = this.actorLabel()
      // Optimistic immédiat (fiche + compteur table) puis reconcile API
      this.applyLocalCall(pk, by)
      this.callOpen = false
      this.$notify({ type: 'success', message: 'Appel historisé' })
      const nextCount = this.crmOf({ pk_lead: pk }).calls_count
      if (nextCount >= MAX_CALLS) {
        setTimeout(() => this.openSms(), 250)
      }
      try {
        if (!this.crmUnavailable) {
          const { data } = await this.$apollo.mutate({
            client: 'MARKET',
            mutation: require('src/graphql/leadmarket/Annonceur/crm/logCrmCall.gql'),
            variables: {
              id_utilisateur: this.userId(),
              pk_lead: pk,
              result: this.callResult,
              callback_at: this.callCallback || null,
              created_by: by
            }
          })
          if (data && data.logCrmCall) {
            this.applyLogCrmCallResponse(pk, data.logCrmCall, by)
          }
        }
      } catch (e) {
        const msg = (e && e.message) || ''
        if (msg.includes('CRM_CALL_LIMIT') || msg.includes('4')) {
          this.$notify({
            type: 'warning',
            message: 'Limite de 4 sollicitations atteinte — utilisez un modèle SMS.'
          })
          this.openSms()
        } else {
          console.warn('logCrmCall failed — keep optimistic call', e)
        }
      }
      this.callCallback = ''
    },
    applyLocalCall(pk, by) {
      const prev = this.crmOf({ pk_lead: pk })
      const calls = [
        ...(prev.calls || []),
        {
          id: 'local-call-' + Date.now(),
          at: this.nowSql(),
          called_at: this.nowSql(),
          by,
          created_by: by,
          result: this.callResult
        }
      ]
      let status = prev.status || 'A_TRAITER'
      if (calls.length >= MAX_CALLS && status === 'A_TRAITER') status = 'INJOIGNABLE'
      this.setCrm(pk, {
        ...prev,
        calls,
        calls_count: calls.length,
        status,
        callback_at: this.callCallback || prev.callback_at
      })
    },
    async sendSms() {
      // Legacy no-op: SMS is copy-only (see copySmsTemplate)
      this.copySmsTemplate()
    },
    async updateCrmState(payload) {
      if (!this.selectedLead) return
      const pk = this.selectedLead.pk_lead
      const by = this.actorLabel()
      const prev = { ...this.crmOf(this.selectedLead) }
      const next = { ...prev, ...payload }
      if (payload.clear_commercial) {
        next.owner_commercial_id = null
        next.owner_commercial_name = null
      } else if (payload.owner_commercial_id != null) {
        next.owner_commercial_name = this.resolveCommercialName(payload.owner_commercial_id)
      }

      // Optimistic + loader — keep UI locked until API confirms
      this.crmStateSaving = true
      this.setCrm(pk, next)
      try {
        if (!this.crmUnavailable) {
          const { data } = await this.$apollo.mutate({
            client: 'MARKET',
            mutation: require('src/graphql/leadmarket/Annonceur/crm/updateCrmLeadState.gql'),
            variables: {
              id_utilisateur: this.userId(),
              pk_lead: pk,
              status: payload.status != null ? payload.status : null,
              callback_at: payload.callback_at != null ? payload.callback_at : null,
              owner_commercial_id: payload.clear_commercial
                ? null
                : payload.owner_commercial_id != null
                  ? payload.owner_commercial_id
                  : null,
              clear_commercial: payload.clear_commercial === true,
              piece_carte_grise: payload.piece_carte_grise != null ? payload.piece_carte_grise : null,
              piece_permis: payload.piece_permis != null ? payload.piece_permis : null,
              piece_releve: payload.piece_releve != null ? payload.piece_releve : null,
              updated_by: by
            }
          })
          if (data && data.updateCrmLeadState) {
            this.mergeCrmApiState(pk, data.updateCrmLeadState)
          }
          // Re-assert fields we explicitly requested (API may return stale/null on first upsert)
          const confirmed = { ...this.crmOf({ pk_lead: pk }) }
          if (payload.status != null) confirmed.status = payload.status
          if (Object.prototype.hasOwnProperty.call(payload, 'callback_at')) {
            confirmed.callback_at = payload.callback_at
          }
          if (payload.clear_commercial) {
            confirmed.owner_commercial_id = null
            confirmed.owner_commercial_name = null
          } else if (payload.owner_commercial_id != null) {
            confirmed.owner_commercial_id = payload.owner_commercial_id
            confirmed.owner_commercial_name = this.resolveCommercialName(payload.owner_commercial_id)
          }
          ;['piece_carte_grise', 'piece_permis', 'piece_releve'].forEach((k) => {
            if (payload[k] != null) confirmed[k] = !!payload[k]
          })
          // Preserve lists always after state update
          confirmed.calls = confirmed.calls || prev.calls || []
          confirmed.sms = confirmed.sms || prev.sms || []
          confirmed.comments = confirmed.comments || prev.comments || []
          this.setCrm(pk, confirmed)
        }
      } catch (e) {
        // Rollback so the select does not stick on a failed value
        this.setCrm(pk, prev)
        console.warn('updateCrmLeadState failed — rolled back', e)
        const detail = this.graphqlErrorMessage(e)
        this.$notify({
          type: 'danger',
          message: detail
            ? 'Échec de la mise à jour CRM — ' + detail
            : 'Échec de la mise à jour CRM — statut restauré'
        })
      } finally {
        this.crmStateSaving = false
      }
    },
    async addComment(text) {
      const body = (text || this.commentDraft || '').trim()
      if (!body || !this.selectedLead) return
      this.commentSaving = true
      const pk = this.selectedLead.pk_lead
      const by = this.actorLabel()
      const entry = {
        id: 'local-comment-' + Date.now(),
        body,
        created_by: by,
        created_at: this.nowSql()
      }
      // Optimistic immédiat
      this.appendCrmList(pk, 'comments', entry)
      this.commentDraft = ''
      try {
        if (!this.crmUnavailable) {
          const { data } = await this.$apollo.mutate({
            client: 'MARKET',
            mutation: require('src/graphql/leadmarket/Annonceur/crm/addCrmComment.gql'),
            variables: {
              id_utilisateur: this.userId(),
              pk_lead: pk,
              body,
              created_by: by
            }
          })
          if (data && data.addCrmComment) {
            const prev = this.crmOf({ pk_lead: pk })
            const comments = (prev.comments || []).map((c) =>
              String(c.id) === String(entry.id) ? { ...entry, ...data.addCrmComment } : c
            )
            const hasApi = comments.some((c) => String(c.id) === String(data.addCrmComment.id))
            this.setCrm(pk, {
              ...prev,
              comments: hasApi
                ? comments
                : [...comments.filter((c) => String(c.id) !== String(entry.id)), data.addCrmComment]
            })
          }
        }
        this.$notify({ type: 'success', message: 'Commentaire enregistré' })
      } catch (e) {
        console.warn('addCrmComment failed — keep local comment', e)
        this.$notify({ type: 'success', message: 'Commentaire enregistré (local)' })
      } finally {
        this.commentSaving = false
      }
    },
    diffDate(date2, date1) {
      return (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)
    },
    renderHeaderMethod(h, { column }) {
      return h('div', [
        h('span', column.label + '  ', { align: 'left' }),
        h(
          'el-popover',
          { props: { placement: 'top-start', width: '300', trigger: 'hover' } },
          [
            h(
              'label',
              "Vous avez 5 jours à partir de la date de livraison pour notifier un motif de dévalidation qui sera contrôlé pour nos services, en cas de motif légitime, le montant du lead sera crédité sur votre solde"
            ),
            h('i', {
              class: 'far fa-question-circle',
              style: 'color:#588bbd;font-size: 18px !important',
              slot: 'reference'
            })
          ]
        )
      ])
    },
    search() {
      this.SkipQuery = false
      this.MyLeads = []
      this.selectedLead = null
      this.detailsCache = {}
      this.selectedFieldGroups = []
      this.detailsMgUnavailable = false
      this.detailsMgConsent = null
    },
    encode_utf8(s) {
      return unescape(encodeURIComponent(s || ''))
    },
    async StatChanged(row) {
      await this.$apollo
        .mutate({
          client: 'MARKET',
          mutation: require('src/graphql/leadmarket/Annonceur/mutation/devaliderLead.gql'),
          variables: {
            id_utilisateur: this.userId(),
            ref: row.pk_bon_commande,
            motif: row.motif
          }
        })
        .then((response) => {
          if (response.data.devaliderLead.state === 'OK') {
            this.$notify({ type: 'success', message: this.$t('apiresponse.Stateupdated') })
          } else if (response.data.devaliderLead.state === 'depasse10') {
            this.$notify({
              type: 'success',
              message: 'Le nombre de dévalidations maximum a été atteint sur votre commande N° ' + row.pk_bon_commande
            })
          } else if (response.data.devaliderLead.state === '') {
            this.$notify({ type: 'warning', message: this.$t('apiresponse.errorupdate') })
          }
        })
        .catch(() => {
          this.$notify({ type: 'warning', message: this.$t('apiresponse.errorupdate') })
        })
    },
    DownloadCSV() {
      if (this.With_fields && !this.ProductSelects.Product) {
        this.$notify({ type: 'warning', message: "Veuillez selectionner un produit pour l' extract" })
        return
      }
      const url_api = 'https://apileadmarket.wee-do-it.net/api/export-Leads-csv'
      const accessToken = localStorage.getItem('token_jwt')
      const formData = new FormData()
      formData.append('id_utilisateur', this.userId())
      formData.append('produit', this.ProductSelects.Product)
      formData.append('statut', this.StatutSelects.Statut)
      formData.append('pack', this.PackSelects.Pack)
      formData.append('facturation', this.FabricationSelects.Fabrication)
      formData.append('date_debut', this.StartDate)
      formData.append('date_fin', this.EndnDate)
      formData.append('with_tag', false)
      formData.append('with_fields', this.With_fields)
      formData.append('export_validate', true)
      formData.append('with_date_collecte', false)
      this.axios
        .post(url_api, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization: `Bearer ${accessToken}`
          },
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'extract.csv')
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => console.log(error))
    },
    checkDevalidation(row) {
      if (this.isAdmin) return false
      if (this.diffDate(new Date(), new Date(row.date_livraison)) > 5 || row.destockage === 1) {
        return true
      }
      return false
    },
    bindFicheDockListeners() {
      this._onFicheDock = () => {
        if (this._ficheDockRaf) return
        this._ficheDockRaf = window.requestAnimationFrame(() => {
          this._ficheDockRaf = null
          this.updateFicheDock()
        })
      }
      // Capture wheel before PerfectScrollbar steals it when cursor is on the fiche
      this._onFicheWheel = (e) => {
        const dock = this.$refs.ficheDock
        if (!dock || !this.selectedLead || this.fullFiche) return
        if (!dock.contains(e.target) && e.target !== dock) return
        // Redirect wheel to the dock; block main-panel PerfectScrollbar
        e.preventDefault()
        e.stopPropagation()
        if (e.stopImmediatePropagation) e.stopImmediatePropagation()
        dock.scrollTop += e.deltaY
      }
      window.addEventListener('resize', this._onFicheDock)
      const panel = document.querySelector('.main-panel')
      this._mainPanelEl = panel
      if (panel) {
        panel.addEventListener('scroll', this._onFicheDock, { passive: true })
        panel.addEventListener('ps-scroll-y', this._onFicheDock)
      }
      document.addEventListener('scroll', this._onFicheDock, true)
      document.addEventListener('wheel', this._onFicheWheel, { capture: true, passive: false })
    },
    unbindFicheDockListeners() {
      window.removeEventListener('resize', this._onFicheDock)
      document.removeEventListener('scroll', this._onFicheDock, true)
      if (this._onFicheWheel) {
        document.removeEventListener('wheel', this._onFicheWheel, { capture: true })
      }
      if (this._mainPanelEl) {
        this._mainPanelEl.removeEventListener('scroll', this._onFicheDock)
        this._mainPanelEl.removeEventListener('ps-scroll-y', this._onFicheDock)
      }
      if (this._ficheDockRaf) {
        window.cancelAnimationFrame(this._ficheDockRaf)
        this._ficheDockRaf = null
      }
    },
    scheduleFicheDock() {
      this.$nextTick(() => {
        this.updateFicheDock()
        // second pass after layout / fonts
        setTimeout(() => this.updateFicheDock(), 50)
      })
    },
    updateFicheDock() {
      if (!this.selectedLead || this.fullFiche) {
        this.ficheDockStyle = null
        return
      }
      const col = this.$refs.ficheCol
      if (!col || window.innerWidth < 1200) {
        // Below xl: keep panel in normal document flow
        this.ficheDockStyle = null
        this.ficheSpacerPx = 0
        return
      }
      const rect = col.getBoundingClientRect()
      const topOffset = 88
      const bottomGap = 16
      const top = rect.top < topOffset ? topOffset : rect.top
      const maxHeight = Math.max(240, window.innerHeight - top - bottomGap)
      this.ficheSpacerPx = Math.max(maxHeight, 360)
      this.ficheDockStyle = {
        position: 'fixed',
        top: top + 'px',
        left: rect.left + 'px',
        width: rect.width + 'px',
        maxHeight: maxHeight + 'px',
        overflowY: 'auto',
        overflowX: 'hidden',
        zIndex: 30
      }
    }
  },
  watch: {
    selectedLead() {
      this.scheduleFicheDock()
    },
    fullFiche() {
      this.scheduleFicheDock()
    }
  },
  mounted() {
    this.SkipQuery = false
    this.loadCommercials()
    this.bindFicheDockListeners()
    this.scheduleFicheDock()
    if (this.operatorId) {
      this.commercialFilter = String(this.operatorId)
    }
    if (!this.tarificationCrmEnabled) {
      this.tarificationFilter = ''
    }
    this._crmFilterKeyHandler = (e) => this.onCrmFilterKeydown(e)
    window.addEventListener('keydown', this._crmFilterKeyHandler)
  },
  beforeDestroy() {
    this.unbindFicheDockListeners()
    if (this._crmFilterKeyHandler) {
      window.removeEventListener('keydown', this._crmFilterKeyHandler)
      this._crmFilterKeyHandler = null
    }
  }
}
</script>

<style>
.customtable_leads .cell {
  word-break: break-word;
}

.crm-product-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
}
.crm-product-icon {
  font-size: 16px;
  color: #588bbd;
  flex-shrink: 0;
  width: 18px;
  text-align: center;
}
.crm-table-filters .form-group {
  margin-bottom: 0;
}
.crm-table-filters .w-100 {
  width: 100%;
}
.crm-filters-primary,
.crm-filters-secondary {
  width: 100%;
  gap: 10px 12px;
}
.crm-search-wrap {
  flex: 1 1 320px;
  min-width: 280px;
  max-width: 480px;
  margin-bottom: 0 !important;
}
.crm-filter-item {
  flex: 0 1 160px;
  min-width: 140px;
  max-width: 220px;
  margin-bottom: 0 !important;
}
.crm-table-filters .crm-search-input,
.crm-table-filters .crm-search-input.el-input {
  width: 100% !important;
  max-width: 100%;
}
.crm-table-filters .crm-search-input .el-input__inner {
  width: 100%;
}
.crm-filters-actions {
  flex: 0 0 auto;
  gap: 4px;
}
.crm-cols-toggle {
  flex: 0 0 auto;
  margin-bottom: 0 !important;
  align-self: flex-end;
}
.crm-cols-toggle .btn {
  margin-bottom: 0 !important;
}
.crm-filter-chips {
  width: 100%;
  gap: 4px;
  min-height: 28px;
}
.crm-filter-chip {
  border-radius: 16px;
  padding: 2px 10px;
  font-size: 12px;
  line-height: 1.4;
}
.crm-filter-chip-x {
  margin-left: 6px;
  font-weight: 700;
  opacity: 0.85;
}
.crm-perpage-wrap {
  min-width: 90px;
}
.crm-perpage-wrap .el-select {
  width: 90px;
}
.crm-bulk-fab {
  position: fixed;
  right: 28px;
  /* Au-dessus du badge Calendly « Planifier un RDV de démo » (bas-droite) */
  bottom: 96px;
  z-index: 1050;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 10px 16px 10px 14px;
  border: 1px solid rgba(88, 139, 189, 0.55);
  border-radius: 28px;
  background: #588bbd;
  color: #fff !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
}
.crm-bulk-fab:hover,
.crm-bulk-fab:focus {
  background: #4a7aaa;
  color: #fff !important;
  outline: none;
}
.crm-bulk-fab:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.crm-bulk-fab .tim-icons {
  font-size: 16px;
}
.crm-bulk-fab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.22);
  font-size: 12px;
}
.crm-bulk-fab-label {
  letter-spacing: 0.02em;
}
@media (max-width: 767px) {
  .crm-bulk-fab {
    right: 16px;
    bottom: 88px;
  }
  .crm-bulk-fab-label {
    display: none;
  }
}

.btn-ouvrir {
  white-space: nowrap !important;
  padding-left: 10px;
  padding-right: 10px;
}
.btn-ouvrir-compact {
  font-size: 11px;
  padding: 4px 8px;
  line-height: 1.2;
  min-width: 0;
}

/*
  Dark theme forces: .el-table table > tbody > tr > td { color: rgba(255,255,255,.7) !important }
  Element UI hover uses both :hover and .hover-row (fixed columns).
*/
/* Ligne « Tarification autre » — fond gris, contraste inchangé au hover */
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre > td,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre > td.el-table__cell {
  background-color: #3a3d4f !important;
}
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre:hover > td,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre:hover > td.el-table__cell,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.hover-row > td,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.hover-row > td.el-table__cell {
  background-color: #fff !important;
  color: #1d253b !important;
}
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.current-row > td,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.current-row > td.el-table__cell {
  background-color: #e9ecef !important;
  color: #1d253b !important;
}
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre:hover > td .cell,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre:hover > td .cell strong,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre:hover > td .cell small,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre:hover > td .cell a,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.hover-row > td .cell,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.hover-row > td .cell strong,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.hover-row > td .cell small,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.hover-row > td .cell a,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.current-row > td .cell,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.current-row > td .cell strong,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.current-row > td .cell small,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.current-row > td .cell a {
  color: #1d253b !important;
}
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre:hover .el-input__inner,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre:hover .el-input__inner::placeholder,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre:hover .el-input__icon,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.hover-row .el-input__inner,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.hover-row .el-input__inner::placeholder,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.hover-row .el-input__icon,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.current-row .el-input__inner,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.current-row .el-input__inner::placeholder,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.current-row .el-input__icon {
  color: #1d253b !important;
}
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre:hover .btn,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.hover-row .btn,
.customtable_leads.el-table table.el-table__body > tbody > tr.crm-row-tarification-autre.current-row .btn {
  color: #fff !important;
}

.customtable_leads.el-table table.el-table__body > tbody > tr:hover > td,
.customtable_leads.el-table table.el-table__body > tbody > tr:hover > td.el-table__cell,
.customtable_leads.el-table table.el-table__body > tbody > tr.hover-row > td,
.customtable_leads.el-table table.el-table__body > tbody > tr.hover-row > td.el-table__cell {
  background-color: #fff !important;
  color: #1d253b !important;
}
.customtable_leads.el-table table.el-table__body > tbody > tr.current-row > td,
.customtable_leads.el-table table.el-table__body > tbody > tr.current-row > td.el-table__cell {
  background-color: #e9ecef !important;
  color: #1d253b !important;
}
.customtable_leads.el-table table.el-table__body > tbody > tr:hover > td .cell,
.customtable_leads.el-table table.el-table__body > tbody > tr:hover > td .cell strong,
.customtable_leads.el-table table.el-table__body > tbody > tr:hover > td .cell small,
.customtable_leads.el-table table.el-table__body > tbody > tr:hover > td .cell a,
.customtable_leads.el-table table.el-table__body > tbody > tr.hover-row > td .cell,
.customtable_leads.el-table table.el-table__body > tbody > tr.hover-row > td .cell strong,
.customtable_leads.el-table table.el-table__body > tbody > tr.hover-row > td .cell small,
.customtable_leads.el-table table.el-table__body > tbody > tr.hover-row > td .cell a,
.customtable_leads.el-table table.el-table__body > tbody > tr.current-row > td .cell,
.customtable_leads.el-table table.el-table__body > tbody > tr.current-row > td .cell strong,
.customtable_leads.el-table table.el-table__body > tbody > tr.current-row > td .cell small,
.customtable_leads.el-table table.el-table__body > tbody > tr.current-row > td .cell a {
  color: #1d253b !important;
}

/* Selects inside hovered / selected rows: dark text on light row */
.customtable_leads.el-table table.el-table__body > tbody > tr:hover .el-input__inner,
.customtable_leads.el-table table.el-table__body > tbody > tr:hover .el-input__inner::placeholder,
.customtable_leads.el-table table.el-table__body > tbody > tr:hover .el-input__icon,
.customtable_leads.el-table table.el-table__body > tbody > tr:hover .el-select .el-input.is-focus .el-input__inner,
.customtable_leads.el-table table.el-table__body > tbody > tr:hover .el-select .el-input:hover .el-input__inner,
.customtable_leads.el-table table.el-table__body > tbody > tr.hover-row .el-input__inner,
.customtable_leads.el-table table.el-table__body > tbody > tr.hover-row .el-input__inner::placeholder,
.customtable_leads.el-table table.el-table__body > tbody > tr.hover-row .el-input__icon,
.customtable_leads.el-table table.el-table__body > tbody > tr.hover-row .el-select .el-input:hover .el-input__inner,
.customtable_leads.el-table table.el-table__body > tbody > tr.current-row .el-input__inner,
.customtable_leads.el-table table.el-table__body > tbody > tr.current-row .el-input__inner::placeholder,
.customtable_leads.el-table table.el-table__body > tbody > tr.current-row .el-input__icon,
.customtable_leads.el-table table.el-table__body > tbody > tr.current-row .el-select .el-input:hover .el-input__inner {
  color: #1d253b !important;
  background-color: #fff !important;
  border-color: #ced4da !important;
}

/* CRM modals — align with market cards (dark), not orphan white frame */
.modal-crm .modal-content {
  background: #27293d;
  border: 1px solid #588bbd;
  color: #fff;
}
.modal-crm .modal-header,
.modal-crm .modal-body,
.modal-crm .modal-footer {
  background: transparent;
  border-color: rgba(88, 139, 189, 0.35);
}
.modal-crm .modal-header .title,
.modal-crm .modal-crm-title,
.modal-crm .modal-header .modal-title,
.modal-crm .modal-header .close,
.modal-crm label,
.modal-crm .form-control,
.modal-crm .modal-body p,
.modal-crm .text-muted {
  color: #fff !important;
}
.modal-crm .text-muted {
  opacity: 0.75;
}
.modal-crm .modal-header .close {
  text-shadow: none;
  opacity: 0.85;
}
.modal-crm .form-control,
.modal-crm .modal-crm-textarea {
  background: #1e1e2f;
  border-color: #588bbd;
  color: #fff;
}
.modal-crm .card {
  background: #27293d;
  border-color: #588bbd;
  color: #fff;
}
.modal-crm-full .modal-dialog {
  max-width: 960px;
}

/*
  Date / datetime picker popup (appended to body):
  keep light panel + dark text — never white-on-white or black-on-black.
*/
.el-picker-panel,
.el-date-picker,
.el-date-range-picker,
.el-time-panel {
  background: #fff !important;
  color: #1d253b !important;
  border: 1px solid #dcdfe6 !important;
}
.el-picker-panel .el-picker-panel__body,
.el-picker-panel .el-picker-panel__content,
.el-picker-panel .el-date-picker__header,
.el-picker-panel .el-date-picker__header-label,
.el-picker-panel .el-date-table th,
.el-picker-panel .el-date-table td,
.el-picker-panel .el-month-table td,
.el-picker-panel .el-year-table td,
.el-picker-panel .el-time-spinner__item,
.el-time-panel .el-time-spinner__item {
  color: #1d253b !important;
}
.el-picker-panel .el-input__inner,
.el-picker-panel .el-input.is-disabled .el-input__inner,
.el-date-picker__editor-wrap .el-input__inner,
.el-date-picker__time-header .el-input__inner,
.el-time-panel__content .el-input__inner,
.el-time-spinner__wrapper .el-scrollbar__wrap {
  background-color: #fff !important;
  color: #1d253b !important;
  border-color: #dcdfe6 !important;
}
.el-picker-panel .el-input__inner::placeholder,
.el-date-picker__editor-wrap .el-input__inner::placeholder {
  color: #909399 !important;
}
.el-picker-panel .el-input__icon,
.el-picker-panel .el-picker-panel__icon-btn {
  color: #606266 !important;
}
.el-picker-panel .el-time-spinner__item:hover:not(.disabled):not(.active),
.el-time-panel .el-time-spinner__item:hover:not(.disabled):not(.active) {
  background: #f5f7fa !important;
  color: #1d253b !important;
}
.el-picker-panel .el-time-spinner__item.active:not(.disabled),
.el-time-panel .el-time-spinner__item.active:not(.disabled) {
  color: #588bbd !important;
  font-weight: 600;
}
.el-picker-panel .el-button,
.el-time-panel__btn {
  color: #1d253b !important;
}
.el-picker-panel .el-button--text {
  color: #588bbd !important;
}
/* "Maintenant" + "OK" footer actions — white label on market blue */
.el-picker-panel__footer .el-button,
.el-picker-panel__footer .el-picker-panel__link-btn,
.el-picker-panel__footer .el-button--text,
.el-picker-panel__footer .el-button--default,
.el-picker-panel .el-picker-panel__link-btn {
  color: #fff !important;
  background-color: #588bbd !important;
  border-color: #588bbd !important;
}
.el-picker-panel__footer .el-button:hover,
.el-picker-panel__footer .el-picker-panel__link-btn:hover,
.el-picker-panel .el-picker-panel__link-btn:hover {
  color: #fff !important;
  background-color: #4a7aa8 !important;
  border-color: #4a7aa8 !important;
}

/* Contact detail dock — fixed beside list (sticky broken by PerfectScrollbar/transform) */
.crm-workspace-split {
  align-items: flex-start;
}
.crm-list-col,
.crm-fiche-col {
  min-width: 0;
}
.crm-fiche-col {
  position: relative;
}
.crm-fiche-dock-spacer {
  width: 100%;
  pointer-events: none;
}
.crm-fiche-dock {
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
}
.crm-fiche-dock.is-fixed {
  padding-right: 4px;
}
.crm-fiche-dock .crm-fiche {
  margin-bottom: 0;
}
.crm-fiche-dock::-webkit-scrollbar {
  width: 6px;
}
.crm-fiche-dock::-webkit-scrollbar-thumb {
  background: rgba(88, 139, 189, 0.55);
  border-radius: 4px;
}
@media (max-width: 1199.98px) {
  .crm-fiche-dock-spacer {
    display: none;
  }
  .crm-fiche-dock {
    position: static !important;
    max-height: 70vh;
    overflow-y: auto;
    width: 100% !important;
    left: auto !important;
    top: auto !important;
  }
}

/* Fiche / filters date inputs on dark UI */
.crm-fiche .el-date-editor .el-input__inner,
.crm-table-filters .el-date-editor .el-input__inner,
.modal-crm .el-date-editor .el-input__inner,
.modal-crm .el-select .el-input__inner {
  background-color: #1e1e2f !important;
  border-color: #588bbd !important;
  color: #fff !important;
}
.crm-fiche .el-date-editor .el-input__inner::placeholder,
.modal-crm .el-date-editor .el-input__inner::placeholder,
.modal-crm .el-select .el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.55) !important;
}
.crm-fiche .el-date-editor .el-input__icon,
.modal-crm .el-date-editor .el-input__icon,
.modal-crm .el-select .el-input__icon {
  color: rgba(255, 255, 255, 0.75) !important;
}
</style>
